import { UserModel } from './../../../model/UserModel';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PaymentService } from 'src/app/services/payment.service';
import { AccountService } from 'src/app/services/account.service';
import { SharedService } from 'src/app/services/shared.service';
import { environment } from 'src/environments/environment';
import { ActiveSessionsReqObj } from 'src/app/model/ApiRequests/ApiReqObj';
import { UserDetailResult, Product } from 'src/app/model/UserDetail';
import { ProductService } from 'src/app/services/product.service';
import { CyberPaySetTransactionRequest, CyberPayLogModel } from 'src/app/model/CyberPay';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { IVATModel } from './../../../model/CyberPay';



@Component({
  selector: 'app-topup',
  templateUrl: './topup.component.html',
  styleUrls: ['./topup.component.css']
})
export class TopupComponent implements OnInit {

  vatModel: IVATModel = {} as IVATModel;


  processing: boolean = false;
  tranSuccess: boolean = false;
  tranFailed: boolean = false;
  userdetail: UserDetailResult;
  customerBalance: number;
  mdn: string;
  i_account: number;
  i_customer: number;
  i_product: number;
  amount: number;
  currentProduct: Product;
  remainingAmount: string;
  paymentMethod: string;
  periodList: any[];
  selectedPeriod: number = 0;
  currentUser: UserModel;
  expiryDate: string;
  chosenPeriod: string;


  constructor(private activatedRoute: ActivatedRoute, private router: Router, private toastr: ToastrService, private sharedService: SharedService, private accountService: AccountService, private paymentService: PaymentService, private productService: ProductService, private authenticationService: AuthenticationService) { }

  async ngOnInit() {

    const acc = this.activatedRoute.snapshot.queryParamMap.get('acc');
    this.currentUser = this.authenticationService.getCurrentUser();

    if (!acc || !this.currentUser) {
      this.toastr.error(environment.GenericErrorMsg, "Error");
      this.router.navigateByUrl('/dashboard');
      return;
    }

    await this.getRenewalObject(parseInt(acc));

  }

  UserIsAuthourised(i_account : string, i_customer:string){
    //deny unauthourised individual accounts
    if(this.currentUser.i_Account != "0"){

      if(this.currentUser.i_Account != i_account){
        return false;
      }

    }
    else{

      //deny unauthorised customer accounts
      if(this.currentUser.i_Customer != i_customer){
          return false;
      }

    }
    return true;
  }

  async getRenewalObject(i_account: number) {

    var model: ActiveSessionsReqObj = {} as ActiveSessionsReqObj;
    model.i_account = i_account;
    model.DownloadType = "ACC:GetDetail";

    let userdetailResult = await this.accountService.getActiveSessionsFromLteHttp(model).toPromise();


    if (!userdetailResult.Status) {
      this.toastr.error(environment.GenericErrorMsg, "Error");
      return;
    }

    let userdetail: UserDetailResult = userdetailResult.Result[0];

    if(!userdetail.i_account){
      this.toastr.error(environment.GenericErrorMsg, "Error");
      return;
    }

    if(!this.UserIsAuthourised(userdetail.i_account.toString(),userdetail.i_customer.toString())){
      this.toastr.error(environment.GenericErrorMsg, "Error");
      return;
    }

    let voiceproduct = userdetail.Product.Name.toLowerCase().includes("voice");

    if (voiceproduct) {
      this.toastr.error("topup is only available on data plans");
      //this.router.navigateByUrl("/dashboard");
      return;
    }

    if(userdetail.AccountState == environment.expiredAccId){
      this.toastr.error("Cannot topup an expired account");
      return;
    }

    this.userdetail = userdetail;
    this.expiryDate = new Date(userdetail.ExpirationDate.toString()).toDateString();
    this.i_account = userdetail.i_account;
    this.i_customer = userdetail.i_customer;
    this.i_product = userdetail.Product.i_product;
    this.mdn = userdetail.ID.toString();
    this.currentProduct = userdetail.Product;
    this.remainingAmount = "₦" + userdetail.Balance.toLocaleString();

    let customerBalanceResult = await this.accountService.getCustomerBalance(userdetail.i_customer).toPromise();
    this.customerBalance = Math.round(customerBalanceResult.Result);

    let productResult = await this.productService.getSingleProductsFromLte(this.i_product).toPromise();
    this.currentProduct = productResult.Result;

    this.calculateTopUp();
    console.log(userdetail);
  }

  calculateTopUp() {
    let amount = this.currentProduct.Price;
    let max = amount - (0.1 * amount);
    let unitAmount = 0.1 * max;
    let total = unitAmount;
    var periodList = [];
    let unitGb = this.currentProduct.Display.DataCapacity.Capacity / this.currentProduct.Price;
    for (let i = 0; i < 10; i++) {

      let amount = total;
      let gb = parseFloat((Math.round((total * unitGb) * 100) / 100).toString()).toFixed(2);
      let period = { value: 0, text: "" };
      period.value = total;
      period.text = `${gb} GB (₦${amount.toFixed(2).toLocaleString()})`;
      periodList.push(period);

      total += unitAmount;
    }

    this.periodList = periodList;
  }

  setSelectedPaymentMethod(option: string) {
    if (option) {
      this.paymentMethod = option;
      return;
    }
  }

 async getSelectedPeriod(value) {
    this.amount = value;
    this.chosenPeriod = this.periodList.find(a => a.value == value).text;
    await this.getVatValue(this.amount);
  }

  Proceed() {

if(this.userdetail.CustomerClass==='Enterprise'){
  this.toastr.error("Account is restricted from topping up");
  return; 
}

    if(this.userdetail.AccountState == environment.expiredAccId){
      this.toastr.error("Cannot topup an expired account");
      return;
    }

    if (this.amount > 0) {

      if (this.paymentMethod == "cyberpay") {
        this.gotoCyberPay();
      }
      else if (this.paymentMethod == "wallet") {
        this.PayWithWallet();
      }

      return;
    }

  }

  clearform() {
    this.chosenPeriod = "";
    this.selectedPeriod = 0;
    this.paymentMethod = "";

  }
  
  async getVatValue(amount) {
    try{
      let vatResult = await this.paymentService.GetVAT(amount).toPromise();
      
      if (vatResult.Status != 1) {
        this.toastr.error('Error, VAT retrieval failed');
        return;
      }
      const vatres: IVATModel = vatResult.Result;
      this.vatModel = vatres;
      return vatres;
    }catch(e){
     // console.log(e);
      this.toastr.error('Error, VAT retrieval failed');
    }
  }
  async PayWithWallet() {
    let totalamount = this.vatModel.ProdVatPrice;
    let vatamount = this.vatModel.VAT;
    let vatRate = this.vatModel.VatPercentage;

    try {

      this.processing = true;
      let userdetail = this.userdetail;

      if (userdetail == undefined) {
        this.toastr.error(environment.GenericErrorMsg, "Error");
        this.processing = false;
        return;
      }

      if (this.customerBalance < totalamount) {
        this.toastr.error("Your datareserve balance is not sufficient for transaction", "insufficient balance");
        this.processing = false;
        return;
      }
      let topupResult = await this.paymentService.LteTopUp(userdetail.i_customer, userdetail.i_account,totalamount,vatamount,vatRate).toPromise();

      if (!topupResult) {
        this.processing = false;
        this.tranFailed = true;
        return;
      }

      this.tranSuccess = true;
      this.processing = false;
      this.clearform();
    }
    catch (err) {
      this.tranFailed = true;
      this.processing = false;
    }

  }


  async gotoCyberPay() {

    try {

      if(this.userdetail.block==environment.pausedAccId){
        this.toastr.error("You cannot top up a paused account. Please contact Customer Care");
        return;
      }

      this.processing = true;
      let userdetail = this.userdetail;



      if (userdetail == undefined) {
        this.processing = false;
        this.toastr.error(environment.GenericErrorMsg, "Error");
        return;
      }
      //adding vat to amount
      this.amount=this.vatModel.ProdVatPrice;

      let cyberpayReq: CyberPaySetTransactionRequest = {} as CyberPaySetTransactionRequest;
      cyberpayReq.Currency = "NGN";
      cyberpayReq.Amount = this.amount * 100;
      cyberpayReq.CustomerEmail = userdetail.Customer.EmailAddress;
      cyberpayReq.CustomerId = userdetail.i_customer.toString();
      cyberpayReq.CustomerMobile = userdetail.Customer.MobilePhone;
      cyberpayReq.CustomerName = `${userdetail.Customer.FirstName} ${userdetail.Customer.LastName}` ;
      cyberpayReq.Description = `Top up data - ${userdetail.ID.replace("@msisdn","")}`;
      cyberpayReq.IntegrationKey = environment.IntegrationKey;
      cyberpayReq.MerchantRef = new Date().getTime().toString();
      cyberpayReq.ProductCode = userdetail.Product.i_product.toString();
      cyberpayReq.ReturnUrl = environment.CyberPayReturnURL;
         cyberpayReq.WebhookUrl = environment.webhookUrl;


      let cyberPayResult = await this.paymentService.cyberPaySetTransaction(cyberpayReq).toPromise();

      if (!cyberPayResult.succeeded) {
        this.processing = false;
        this.toastr.error("An error occured trying to set transaction, try again", "Error");
        return;
      }

      let cyberPayLogModel: CyberPayLogModel = {} as CyberPayLogModel;
      cyberPayLogModel.PortalCode = environment.PortalCode;
      cyberPayLogModel.CustomerID = userdetail.i_customer;
      cyberPayLogModel.DateCreated = new Date().toISOString();
      cyberPayLogModel.CustomerDesc = "CustomerID";
      cyberPayLogModel.Email = cyberpayReq.CustomerEmail;

      cyberPayLogModel.FullName = userdetail.Customer.FirstName + " " + userdetail.Customer.LastName;

      cyberPayLogModel.ItemCode = "0";
      cyberPayLogModel.ItemName = "ExtraData Purchase";

      let session = `Account-${userdetail.i_account}-${this.currentUser.UserID}*${new Date().getTime().toString()}`;
      cyberPayLogModel.PhoneNumber = cyberpayReq.CustomerMobile;
      cyberPayLogModel.OperatorID = environment.OperatorID;
      cyberPayLogModel.RedirectLink = cyberPayResult.data.redirectUrl;
      cyberPayLogModel.Request_Payload = JSON.stringify(cyberpayReq);
      cyberPayLogModel.Session = session;
      cyberPayLogModel.TransRef = cyberPayResult.data.transactionReference;
      cyberPayLogModel.Transaction_status = "PENDING";
      cyberPayLogModel.Value = this.amount;
      cyberPayLogModel.amount = this.amount;
      cyberPayLogModel.i_account = userdetail.i_account;
      cyberPayLogModel.i_customer = userdetail.i_customer;
      cyberPayLogModel.i_product = 0;
      cyberPayLogModel.provider_id = environment.OperatorID;
      //added vat
      cyberPayLogModel.AllocateAll=true;
      cyberPayLogModel.VAT = this.vatModel.VAT;
      cyberPayLogModel.VatPercentage = this.vatModel.VatPercentage;
      cyberPayLogModel.ProdVatPrice = this.vatModel.ProdVatPrice;

      await this.paymentService.LteHttpLogCyberPayRequest(cyberPayLogModel).toPromise();
      window.location.href = cyberPayResult.data.redirectUrl;
    }
    catch (err) {
      this.processing = false;
      this.tranFailed = true;
    }

  }


}
